// Display names for modules whose label and whose code differ.
//
// ASSET LIFECYCLE MANAGEMENT is the name people use; ASSET_MANAGEMENT is what
// the backend stores -- the feature codes, the pageMeta pageName, the Casbin
// policies and every row already written. Renaming the code would mean a data
// migration for a wording change, so only the label moves.
//
// Defined once because it appears in the nav, the page header, the breadcrumb,
// the empty state and three export emails, and a rename that reaches five of
// those reads as a half-finished rename.
//
// THE HEADER ITSELF STILL COMES FROM CONFIG. pageMeta.pageHeader wins wherever
// it is set, so an org that calls this something else keeps its own word; this
// is the fallback and the name used where no config is in hand.
export const ASSET_MANAGEMENT_LABEL = "Asset Lifecycle Management";
